import { cloneDeep } from 'lodash-es';
import type { PiniaPluginContext } from 'pinia';
import type { PersistenceOptions } from 'pinia-plugin-persistedstate';
import { getScopedPersistKey, sanitizePagePersistState } from '@/helpers/persistScope';

interface SortByItem {
    key: string;
    order: string;
}

type PersistPanelStore = Parameters<typeof sanitizePagePersistState>[0];

export function createStorePersistConfig(storeId: string, primaryId: string, defaultSortBy?: SortByItem[]): PersistenceOptions | false {
    if (storeId !== primaryId) return false;

    return {
        key: () => getScopedPersistKey(primaryId),
        pick: ['hiddenFilters', 'visibleFiltersMobile', 'filterOrder', 'useButtonForFiltersApply', 'saveFiltersState', 'hiddenColumns', 'options'],
        serializer: {
            serialize: (value: any) => {
                const serialized = cloneDeep(value);
                if (serialized.options && typeof serialized.options === 'object') {
                    serialized.options.page = 1;
                    if (defaultSortBy) delete serialized.options.sortBy;
                }
                return JSON.stringify(serialized);
            },
            deserialize: (value: string) => {
                const parsed = JSON.parse(value);
                if (parsed.options && typeof parsed.options === 'object') {
                    parsed.options.page = 1;
                    if (defaultSortBy) parsed.options.sortBy = defaultSortBy;
                }
                return parsed;
            },
        },
        afterHydrate: (context: PiniaPluginContext) => {
            sanitizePagePersistState(context.store as PersistPanelStore);
        },
    };
}
